var React = require('react');

function Component (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 28.0039C21.732 28.0039 28 21.7359 28 14.0039C28 6.27192 21.732 0.00390625 14 0.00390625C6.26801 0.00390625 0 6.27192 0 14.0039C0 21.7359 6.26801 28.0039 14 28.0039Z","fill":"white","key":0}),React.createElement("path",{"d":"M19.4503 18.0492L20.0705 14.0014H16.1881V11.3751C16.1881 10.2686 16.7295 9.18776 18.4699 9.18776H20.2359V5.74241C20.2359 5.74241 18.6333 5.46875 17.1016 5.46875C13.9043 5.46875 11.8134 7.40602 11.8134 10.9163V14.0014H8.25781V18.0492H11.8134V27.832C12.5261 27.9442 13.2565 28.0013 14.0007 28.0013C14.7449 28.0013 15.4754 27.9423 16.1881 27.832V18.0492H19.4503Z","fill":"black","key":1})]);
}

Component.defaultProps = {"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none"};

module.exports = Component;

Component.default = Component;
